import React, { useState } from "react";
import { Link } from "gatsby";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import "../styles/bootstrap.min.css";
import "../styles/main.css";
import "../styles/header.css";
import "../styles/element.css";
import "../styles/fontawesome.css";

const Alert = ({ showIsmAlert, showJpjAlert, lang, showJpjType }) => {
    const [showCampaignAlert, setShowCampaignAlert] = useState(true);

    const isEnglish = lang.id === "EN" ? true : false;

    return (
        <>
            <div className="alert-note" hidden={!showCampaignAlert}>
                <div className="alert-bg">
                    <span
                        className="closebtn"
                        onClick={() => setShowCampaignAlert(false)}
                    >
                        ×
                    </span>
                    <i className="fas fa-exclamation-circle"></i>{" "}
                    <span className="bold">
                        NOTICE ON SCHEDULED MAINTENANCE{" "}
                    </span>
                    <br />
                    <div className="row">
                        {/* Normal maintenance message */}
                        {showIsmAlert && (
                            <div className="col-md-12 pad-left pt-1">
                                {isEnglish
                                    ? "We would like to advise that we will undergo scheduled system maintenance from 23 January 2025 (10:00pm MY time) to 24 January 2025 (1:00am MY time). During this maintenance period, you will not be able to purchase or renew your insurance policies with Berjaya Sompo Insurance. We apologize for any inconvenience caused."
                                    : "Kami ingin memaklumkan bahawa sistem kami akan menjalankan sistem penyelenggaraan perbankan pada 23 Januari 2025 (10:00pm waktu MY) hingga 24 Januari 2025 (1:00am waktu MY). Sepanjang tempoh ini, anda tidak dapat membeli atau memperbaharui polisi insurans anda dengan Berjaya Sompo Insurance. Kami memohon maaf atas segala kesulitan yang dialami."}
                            </div>
                        )}

                        {/* JPJ maintenance message */}
                        {showJpjAlert && showJpjType===1 && (
                            <div className="col-md-12 pad-left pt-1">
                                {isEnglish
                                    ? "We would like to advise that JPJ will undergo scheduled system maintenance from 28 February 2025 (10:00pm MY time) to 01 March 2025 (6:00am MY time). During this maintenance period, you will be able to purchase your insurance policies with Berjaya Sompo Insurance, but your JPJ status will not be updated. The status will resume to normal right after the maintenance is completed. We apologise for any inconveniences caused."
                                    : "Kami ingin memaklumkan bahawa sistem JPJ akan menjalankan sistem penyelenggaraan perbankan pada 28 Februari 2025 (10:00pm waktu MY)  hingga 01 Mac 2025 (6:00am waktu MY). Sepanjang tempoh ini, anda masih boleh membeli polisi insurans anda dengan Berjaya Sompo Insurance tetapi status JPJ anda tidak akan dikemas kini. Status tersebut akan kembali beroperasi seperti biasa sebaik sahaja penyelenggaraan selesai. Kami memohon maaf atas segala kesulitan yang dialami."}
                            </div>
                        )}

                        {showJpjAlert && showJpjType===2 && (
                            <div className="col-md-12 pad-left pt-1">
                                {isEnglish
                                    ? "We would like to advise that JPJ will undergo scheduled system maintenance from 11 February 2025 (10:00pm MY time) to 12 February 2025 (5:00am MY time). During this maintenance period, you will be able to purchase your insurance policies with Berjaya Sompo Insurance, but your JPJ status will not be updated. The status will resume to normal right after the maintenance is completed. We apologise for any inconveniences caused."
                                    : "Kami ingin memaklumkan bahawa sistem JPJ akan menjalankan sistem penyelenggaraan perbankan pada 11 Februari 2025 (10:00pm waktu MY)  hingga 12 Februari 2025 (5:00am waktu MY). Sepanjang tempoh ini, anda masih boleh membeli polisi insurans anda dengan Berjaya Sompo Insurance tetapi status JPJ anda tidak akan dikemas kini. Status tersebut akan kembali beroperasi seperti biasa sebaik sahaja penyelenggaraan selesai. Kami memohon maaf atas segala kesulitan yang dialami."}
                            </div>
                        )}

                        {showJpjAlert && showJpjType===3 && (
                            <div className="col-md-12 pad-left pt-1">
                                {isEnglish
                                    ? "We would like to advise that JPJ will undergo scheduled system maintenance from 19 February 2025 (10:00pm MY time) to 20 February 2025 (5:00am MY time). During this maintenance period, you will be able to purchase your insurance policies with Berjaya Sompo Insurance, but your JPJ status will not be updated. The status will resume to normal right after the maintenance is completed. We apologise for any inconveniences caused."
                                    : "Kami ingin memaklumkan bahawa sistem JPJ akan menjalankan sistem penyelenggaraan perbankan pada 19 Februari 2025 (10:00pm waktu MY)  hingga 20 Februari 2025 (5:00am waktu MY). Sepanjang tempoh ini, anda masih boleh membeli polisi insurans anda dengan Berjaya Sompo Insurance tetapi status JPJ anda tidak akan dikemas kini. Status tersebut akan kembali beroperasi seperti biasa sebaik sahaja penyelenggaraan selesai. Kami memohon maaf atas segala kesulitan yang dialami."}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Alert;
